import { IMessageTypeBubble } from "../MessagePanel";
import Box from "@mui/material/Box";

const InfoBubble = ({ children }: IMessageTypeBubble) => {
  return <Box sx={{ textAlign: "center" }}>{children}</Box>;
};
export default InfoBubble;
